import { Component, inject } from '@angular/core';
import { BaseWidgetComponent } from '../../../../../home/home-widgets/widgets/base-widget.component';
import { DriverOverviewService, FilterService } from '../../../../../_shared/services';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { PerformanceModalComponent } from '../../modals/performance-modal/performance-modal.component';
import { endOfDay, startOfDay, subDays } from 'date-fns';
import { SummaryRequest } from '../../../../../_shared/models';
import { ErrorHandlerService } from '../../../../../_shared/services/error-handler.service';
import { KpiWidgetComponent } from '../../../../../_shared/components/kpi-widget/kpi-widget.component';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-driver-performance-widget',
  standalone: true,
  imports: [KpiWidgetComponent, TranslocoPipe],
  templateUrl: './driver-performance-widget.component.html',
  styleUrl: './driver-performance-widget.component.scss',
})
export class DriverPerformanceWidgetComponent extends BaseWidgetComponent {
  hasError: boolean = false;
  errorMessage: string = '';

  private modalService = inject(NgbModal);
  private driverOverviewService = inject(DriverOverviewService);
  private errorHandlerService = inject(ErrorHandlerService);

  constructor() {
    const filterService = inject(FilterService);
    super(filterService);
    this.value = 0;
    this.percentageDifference = 0;
    this.difference = 0;
    this.isLoading = true;
    this.hasError = false;
    this.errorMessage = '';
  }

  protected override async onFilterChangeAsync(): Promise<void> {
    this.hasError = false;
    this.isLoading = true;

    try {
      let currentDate = new Date();
      let request: SummaryRequest = {
        accountIds: [...this.widgetFilter.accountIds],
        timeFrom: startOfDay(currentDate),
        timeTo: endOfDay(currentDate),
        previousTimeFrom: subDays(startOfDay(currentDate), 1),
        previousTimeTo: subDays(endOfDay(currentDate), 1),
      }

      this.cancelSubject.next();
      const response = await this.driverOverviewService.getDriverPerformanceSummary(request, this.cancelSubject);
      this.value = response.data?.currentValue ?? 0;
      this.percentageDifference = response.data?.percentageDifference ?? 0;
      this.difference = response.data?.difference ?? 0;

      this.isLoading = false;
    } catch (error: any) {
      this.errorHandlerService.handleError(error, {
        callback: (message) => {
          this.errorMessage = message;
          this.hasError = true;
          this.isLoading = false;
        }
      });
    }
  }

  public override formatValue(value: number): string {
    return `${value.toLocaleString()}%`;
  }

  formatDifference(differenceSign: string, difference: number, percentageSign: string, percentage: number): string {
    return `${differenceSign}${difference.toLocaleString()}%(${percentageSign}${percentage.toLocaleString('default', { maximumFractionDigits: 2 })}%)`;
  }

  public openPerformanceModal(): void {
    if (this.isLoading || this.hasError) return;

    const modalOptions: NgbModalOptions = {
      centered: true,
      backdrop: 'static',
      size: 'xl',
    };

    const modalRef = this.modalService.open(
      PerformanceModalComponent,
      modalOptions
    );

    modalRef.componentInstance.widgetFilter = this.widgetFilter;
  }
}